import { render, staticRenderFns } from "./SignUpOTPVerification.vue?vue&type=template&id=2277e246&scoped=true"
import script from "./SignUpOTPVerification.vue?vue&type=script&lang=js"
export * from "./SignUpOTPVerification.vue?vue&type=script&lang=js"
import style0 from "./SignUpOTPVerification.vue?vue&type=style&index=0&id=2277e246&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277e246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2277e246')) {
      api.createRecord('2277e246', component.options)
    } else {
      api.reload('2277e246', component.options)
    }
    module.hot.accept("./SignUpOTPVerification.vue?vue&type=template&id=2277e246&scoped=true", function () {
      api.rerender('2277e246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sections/SignUpOTPVerification.vue"
export default component.exports